import { useState, useEffect } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/views/base/app/appModel";
import { beService } from "@/views/base/be/beService";
import { IMdOrgDetail, orgService } from "@/views/base/org/orgService";
import { ITreeData } from "@/views/base/dict/dictModel";
import { OptionDsType } from "@/types/FmsTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { ContractSummarySearch, ContractResult } from "@/views/contract/manage/ContractManageTypes";

export enum SummaryActionTypeEnum {
    CONTRACT,
    CUSTOMER
}
export const useSummaryModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode } } = useGlobalModel();

    const [loading, setLoading] = useState(false)
    //查询条件
    const [searchParam, setSearchParam] = useState<ContractSummarySearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ContractResult[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>();
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<ContractResult | undefined>();
    //详情搜索key
    const [detailCode, setDetailCode] = useSessionStorageState<string>("contract.detail.code");
    const [detailPartner, setDetailPartner] = useSessionStorageState<string>("contract.detail.partner");

    //调额弹窗
    const [adjustMonthDrawerVisible, setAdjustMonthDrawerVisible] = useState(false);


    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();

    useEffect(() => {
        //orgService.orgTreeDs({}).then(ds => { setOrgDs(ds) })
        //beService.beDs({}).then(ds => setBeDs(ds))
    }, []);

    const updateSearchParam = (updateParam: ContractSummarySearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ContractSummarySearch = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg?.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg?.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await contractManageService.contractSummaryPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        setLoading(false);
    }

    return {
        /***field***/
        //orgDs, beDs,
        loading,
        initPgCfg,
        searchParam,
        detailCode,
        detailPartner,
        /***method***/
        dataSource, setDataSource,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
        pgCfg,
        resetSearchParam,
        updateSearchParam,
        setDetailCode,
        setDetailPartner,
        loadData,
        adjustMonthDrawerVisible, setAdjustMonthDrawerVisible,
    }
});
